import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateWorkflowEdgeMutationVariables = Types.Exact<{
  input: Types.CreateWorkflowEdgeInput;
}>;

export type CreateWorkflowEdgeMutation = {
  __typename?: 'Mutation';
  createWorkflowEdge: {
    __typename?: 'WorkflowGraphEdge';
    id: any;
    sourceId: any;
    targetId: any;
    sourceHandle?: string | null;
    targetHandle?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export const CreateWorkflowEdgeDocument = gql`
  mutation CreateWorkflowEdge($input: CreateWorkflowEdgeInput!) {
    createWorkflowEdge(input: $input) {
      id
      sourceId
      targetId
      sourceHandle
      targetHandle
      createdAt
      updatedAt
    }
  }
`;
export type CreateWorkflowEdgeMutationFn = Apollo.MutationFunction<
  CreateWorkflowEdgeMutation,
  CreateWorkflowEdgeMutationVariables
>;

/**
 * __useCreateWorkflowEdgeMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowEdgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowEdgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowEdgeMutation, { data, loading, error }] = useCreateWorkflowEdgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowEdgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowEdgeMutation,
    CreateWorkflowEdgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowEdgeMutation,
    CreateWorkflowEdgeMutationVariables
  >(CreateWorkflowEdgeDocument, options);
}
export type CreateWorkflowEdgeMutationHookResult = ReturnType<
  typeof useCreateWorkflowEdgeMutation
>;
export type CreateWorkflowEdgeMutationResult =
  Apollo.MutationResult<CreateWorkflowEdgeMutation>;
export type CreateWorkflowEdgeMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowEdgeMutation,
  CreateWorkflowEdgeMutationVariables
>;
